import { projectFirestore } from '../../firebase/config'
import { useEffect, useState } from 'react'
// styles
import './Home.css'

// components
import CardList from '../../components/CardList'

export default function Home() {
    const [data, setData] = useState(null)
    const [isPending, setIsPending] = useState(false)
    const [error, setError] = useState(false)

    useEffect(() => {
        setIsPending(true)
        projectFirestore.collection('homeLinks').get().then((snapshot)=> {
         if (snapshot.empty) {
             setError('No projects to load')
             setIsPending(false)
         } else {
             let results = []
             snapshot.docs.forEach(doc => {
                 results.push({ id: doc.id, ...doc.data() })
             })
             setData(results.reverse())
             setIsPending(false)
         }
        }).catch(err => {
            setError(err.message)
            setIsPending(false)
        })
    }, [])

    return (
        <div className='home'>
            {error && <p className='error'>{error}</p>}
            {isPending && <p className='loading'>Loading...</p>}
            {data && <CardList cards={data}/>}
        </div>
    )
}